import { useState } from "react";
import "./FAQ.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import ArrowDown from "../../assets/icons/Group 33921.svg";
import Breadcrums from "../../components/breadcrums/Breadcrums";
import Flower from "../../assets/img/lotus-978659_1280.jpg";
import FallbackImg from "../../components/FallbackImg";

// Example FAQ data structure
const faqData = [
  {
    category: "Account Issue",
    questions: [
      {
        q: "How to register?",
        a: (
          <>
            Please click on the link for video guidance:
            https://www.youtube.com/watch?v=3qbu-btBVio
            <FallbackImg
              src={Flower}
              alt="flower"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "fill",
              }}
            />
          </>
        ),
      },
      { q: "How to verify", a: "" },
      { q: "How to login?", a: "" },
      { q: "How to change my password?", a: "" },
      { q: "How to reset my password?", a: "" },
      { q: "How to update my profile?", a: "" },
      { q: "How to sign out?", a: "" },
    ],
  },
  {
    category: "Cart Issue",
    questions: [{ q: "How to add to cart?", a: "" }],
  },
  {
    category: "Checkout Issue",
    questions: [{ q: "How to checkout?", a: "" }],
  },
  {
    category: "Document Issue",
    questions: [{ q: "How to check my document and download?", a: "" }],
  },
  {
    category: "Favourite Issue",
    questions: [
      { q: "How to add product to favourite and view my favourite?", a: "" },
    ],
  },
  {
    category: "Function Issue",
    questions: [
      { q: "How to compare product?", a: "" },
      { q: "How to filter product?", a: "" },
      { q: "How to view product detail?", a: "" },
    ],
  },
  {
    category: "Order Issue",
    questions: [
      { q: "How to check my order status?", a: "" },
      { q: "How to cancel order?", a: "" },
    ],
  },
  {
    category: "Payment Issue",
    questions: [
      { q: "How to make payment (FPX)?", a: "" },
      { q: "How to make paymen (IBG)?", a: "" },
      { q: "How to make payment (Cheque)?", a: "" },
      { q: "How to check my payment status?", a: "" },
    ],
  },
  {
    category: "Refund",
    questions: [
      { q: "How to apply for refund?", a: "" },
      { q: "How to cancel my refund?", a: "" },
      { q: "How to check my refund status?", a: "" },
    ],
  },
  {
    category: "Wishlist Issue",
    questions: [
      { q: "How to add product to my wishlist and view my wishlist", a: "" },
    ],
  },
  {
    category: "Repair Issue",
    questions: [
      { q: "How to apply for repair (stock set)?", a: "" },
      { q: "How to apply for repair (consumer set)?", a: "" },
    ],
  },
];

const FAQ = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [search, setSearch] = useState("");

  // Filter logic
  const filteredFaqData = faqData
    .map((cat) => ({
      ...cat,
      questions: cat.questions.filter((q) =>
        q.q.toLowerCase().includes(search.toLowerCase())
      ),
    }))
    .filter((cat) => cat.questions.length > 0);

  return (
    <div className="faq">
      <Breadcrums />

      <div className="faq-content">
        <div className="faq-main">
          <div className="searchbar-faq-container">
            <div className="searchbar-faq">
              <input
                type="text"
                placeholder="Search your question"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div
                className="searchbar-faq-remove"
                style={{
                  visibility: search ? "visible" : "hidden",
                  pointerEvents: search ? "auto" : "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setSearch("");
                }}
              >
                &#x2715;
              </div>
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                style={{ color: "#798777", width: "40px" }}
              />
            </div>
          </div>
        </div>

        <div className="faq-sub">
          {filteredFaqData.length === 0 && (
            <div style={{ padding: "2rem", color: "#888" }}>
              No questions found.
            </div>
          )}
          {filteredFaqData.map((cat, catIdx) => (
            <div className="faq-item" key={cat.category}>
              <div className="faq-left">
                <div className="faq-subtitle">{cat.category}</div>
              </div>
              <div className="faq-right">
                {cat.questions.map((q, idx) => (
                  <div className="faq-right-container" key={q.q}>
                    <div
                      className="faq-ques"
                      onClick={() =>
                        setOpenFaq(
                          openFaq === `${catIdx}-${idx}`
                            ? null
                            : `${catIdx}-${idx}`
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {q.q}
                      <div className="arrowdown-container">
                        <FallbackImg
                          src={ArrowDown}
                          alt="arrow"
                          width="15"
                          height="15"
                          className={
                            openFaq === `${catIdx}-${idx}` ? "rotate" : ""
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={`faq-ans${
                        openFaq === `${catIdx}-${idx}` ? " show" : ""
                      }`}
                    >
                      {q.a}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
